import { auth, ADMIN_UID } from "./db/firebase.js";
import { signInWithEmailAndPassword } from "firebase/auth";

const loginForm = document.getElementById("admin-login-form");
if (loginForm) {
  loginForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const email = document.getElementById("admin-email").value;
    const password = document.getElementById("admin-password").value;

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password,
      );
      const uid = userCredential.user.uid;

      if (uid === ADMIN_UID) {
        // alert("Admin logged in!");
        window.location.href = "index.html";
      } else {
        alert("Not an admin");
        await auth.signOut();
      }
    } catch (err) {
      console.error(err.message);
      document.getElementById("admin-login-error").innerText =
        "Неправильный email или пароль";
    }
  });
}
